import { isFinite } from "lodash";
import numbro from "numbro";

export function formatNumber(value) {
  if (value === "$_") return "0";

  return isFinite(value) ? numbro(value).format("0,0") : value;
}
